/**
 * Route guard — renders children only when a user is signed in.
 *
 * In dev mode (no Clerk key), the guard is a no-op and just renders children.
 * In prod, unsigned visitors get the ``<SignIn />`` UI from Clerk.
 */

import { SignedIn, SignedOut, SignIn } from "@clerk/clerk-react";
import type { ReactNode } from "react";
import { env } from "@/config/env";

type RequireAuthProps = {
  children: ReactNode;
};

export function RequireAuth({ children }: RequireAuthProps) {
  if (!env.clerkPublishableKey) {
    return <>{children}</>;
  }

  return (
    <>
      <SignedIn>{children}</SignedIn>
      <SignedOut>
        <div className="grid min-h-screen place-items-center p-6">
          <SignIn
            routing="hash"
            appearance={{
              elements: {
                card: "bg-surface border border-stroke-strong",
                rootBox: "font-sans",
              },
            }}
          />
        </div>
      </SignedOut>
    </>
  );
}
